import {FeatureConfig} from '@/utils/constants/featuresFlag'
import {GrowthBook} from '@growthbook/growthbook-react'

const growthBookApiHost = import.meta.env[FeatureConfig.growthbookURL]
const growthBookClientKey = import.meta.env[FeatureConfig.growthbookSdkKey]

// Create a GrowthBook instance
const gb = new GrowthBook({
  apiHost: growthBookApiHost,
  clientKey: growthBookClientKey,
  enableDevMode: import.meta.env.MODE === 'development',
})

if (growthBookClientKey) {
  gb.init({
    // Optional, enable streaming updates
    streaming: false,
    timeout: 1000,
  })
}

export default gb
